/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
import {Pipe, PipeTransform} from '@angular/core';
import {SafeUrl} from '@angular/platform-browser';
import {Observable} from 'rxjs';
import {RuntimeCacheService} from '../services/runtime-cache.service';

@Pipe({
    name: 'secure',
    standalone: false
})
export class SecureXhrDownloadPipe implements PipeTransform {

    constructor(private runTimeCache: RuntimeCacheService) {
    }

    transform(url?: string | null): Observable<SafeUrl | null> {
        return this.runTimeCache.getCachedImage(url);
    }
}